import { criarParticipante } from '@/uteis/action/tramite/participante'

export const criarDestino = (dadosSessao) => {
  var destino = criarParticipante(dadosSessao.descricaoDepartamento, dadosSessao.idDepartamento, 'ID', dadosSessao.siglaDepartamento)
  destino.participantePai = criarParticipante(dadosSessao.descricaoOrgao, dadosSessao.idOrgao, 'ID', dadosSessao.siglaOrgao)

  return destino
}
